import { ExclamationCircleOutlined } from '@ant-design/icons'
import { css } from '@emotion/react'
import { colors } from '@kmns-internal/furikake'
import { Flex, Tag } from 'antd'
import { ClampText } from 'src/components/clampText/ClampText'
import { useLimitedFeatureAvailability } from 'src/features/featureAvailability/useLimitedFeatureAvailability'
type Props = {
  reportName: string
  traceTags: string[]
  hasSomeDeviatedAnswer?: boolean
}

/**
 * レポート名のセル
 */
export const ReportNameCell = ({
  reportName,
  hasSomeDeviatedAnswer = false,
  traceTags,
}: Props) => {
  const { isFeatureAvailable } = useLimitedFeatureAvailability()
  return (
    <Flex vertical gap="small">
      <div css={styles.container}>
        <ClampText line={2}>{reportName}</ClampText>
        {hasSomeDeviatedAnswer && (
          <Tag css={styles.errorTag}>
            <ExclamationCircleOutlined css={styles.errorIcon} />
            逸脱
          </Tag>
        )}
      </div>
      {isFeatureAvailable('reportTrace') && (
        <Flex gap="8px 0" style={{ overflow: 'hidden' }}>
          {traceTags.map((tag, index) => (
            <Tag
              key={index}
              bordered={false}
              style={{
                color: 'black',
                backgroundColor: colors.background.default,
              }}
            >
              {tag}
            </Tag>
          ))}
        </Flex>
      )}
    </Flex>
  )
}

const styles = {
  container: css`
    align-items: center;
    display: flex;
    justify-content: flex-start;
    overflow: hidden;
  `,
  errorTag: css`
    border: none;
    margin-left: 8px;
    padding: 1px 8px;
    color: #f03e3e;
    background-color: #fff5f5;
  `,
  errorIcon: css`
    margin-right: 4px;
  `,
}
